import {CookieService} from 'ngx-cookie-service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  public user: any;

  constructor(private cookieService: CookieService,
              private httpClient: HttpClient,
              private router: Router) {
  }

  public getUser(): Promise<any> {
    return new Promise((resolve) => {
      if (this.user) {
        return resolve(this.user);
      }

      this.httpClient.get('user/me').subscribe((user) => {
        this.user = user;

        resolve(user);
      }, () => {
        this.cookieService.delete('Token');

        this.router.navigate(['login']);
      });
    });
  }

  public isUserBelongsTo(roleName: string): boolean {
    if (this.user) {
      return this.user.role_alternate_name === roleName;
    } else {
      return false;
    }
  }

  public isUserBelongsToWithdrawalRoles(roleName: string, salesGroupIds: string): boolean {
    if (this.user) {
      return (roleName === 'basicUser' || roleName === 'transportManager' || roleName === 'technicalManager');
    } else {
      return false;
    }
  }

  public isUserInternal(config?: any): boolean {
    if (config) {
      const model = config.filter && config.filter === 'type_id=3' ? 'repair' : 'maintenance';
      if ((this.user.role_id === 11 &&
        this.user.is_internal === 0 &&
        this.user.sales_group_ids.indexOf('2001') !== -1 &&
        model === 'repair') || this.user.is_internal === 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return this.user.is_internal === 1;
    }
  }

  public logout(): void {
    this.user = null;

    this.cookieService.delete('Token');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
